<template>
  <div class="xdh-select-footer">
    <slot></slot>
    <el-button @click="handleSubmit" size="mini" type="primary" v-if="submit">确定</el-button>
    <el-button @click="handleClear" size="mini" v-if="clear">重置</el-button>
    <el-button @click="handleClose" size="mini" v-else>取消</el-button>
  </div>
</template>

<script>
/* eslint-disable */ // 在这个文件中禁用eslint
  export default {
    props: {
      clear: {
        type: Boolean,
        default: true
      },
      submit: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      handleClear () {
        this.$emit('on-clear')
      },
      handleSubmit () {
        this.$emit('on-submit')
      },
      handleClose () {
        this.$emit('on-close')
      }
    }
  }
</script>

<style lang="scss">
  .xdh-select-footer {
    display: flex;
    display: -webkit-flex;
    justify-content:center;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/xdhWidgets/xdh-tree-select/select-footer.vue